var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4VSideViewTableDown = function Svg4VSideViewTableDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28.159 23.412 9 2.824 28.159l10.967 8.165h19.242zm-6.154-1.629H8.977l14.435-13.432zm-23.061 6.793L9.691 29.53h27.442l-5.094 3.793z"
  })));
};
export default Svg4VSideViewTableDown;